import { forwardRef } from 'react';
export const MailIcon = forwardRef(({ ...props }, ref) => {
  return (
    <>
      <svg
        width="19"
        height="17"
        viewBox="0 0 19 17"
        fill="none"
        {...props}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.09815 11.4195L18.2449 4.80835V14.8741C18.2449 15.8594 17.6124 16.6501 16.8291 16.6501H1.42074C0.637432 16.6501 0.00494576 15.8594 0.00494576 14.8802V4.81443L9.09815 11.4195Z"
          fill={props?.color ?? '#3D5A80'}
        />
        <path
          d="M18.2254 3.77419L9.12247 10.3428L0.0195351 3.77419L7.43866e-05 3.81676V2.11987C7.43866e-05 1.14067 0.632561 0.350006 1.41587 0.350006H16.8291C17.6124 0.350006 18.2449 1.14067 18.2449 2.11987V3.81676L18.2254 3.77419Z"
          fill={props?.color ?? '#3D5A80'}
        />
      </svg>
    </>
  );
});
